import { render } from "./ListeUserPage.vue?vue&type=template&id=96010c2a&ts=true"
import script from "./ListeUserPage.vue?vue&type=script&lang=ts"
export * from "./ListeUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__